export enum eQuizQuestionType {
  MCQ = 1,
  TrueOrFalse = 2,
  FillInTheBlank = 3,
}
